/**
 * BudgetReleaseValueTypeService
 * Service for BudgetReleaseValueType lookup CRUD operations
 * (1 Percent per month / 2 FixedAmount per month).
 */
import { CrudService } from '../base/CrudService';
/** Service for BudgetReleaseValueType CRUD operations */
export class BudgetReleaseValueTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetReleaseValueTypeService.DEFAULT_SERVICE_PATH,
            basePath: BudgetReleaseValueTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BudgetReleaseValueTypeService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetReleaseValueTypeService.BASE_PATH = 'api/budget-release-value-types';
//# sourceMappingURL=BudgetReleaseValueTypeService.js.map